// Module
var code = "<record-grid-view grid-data-source=\"stateController.gridDataSource\" grid-settings=\"stateController.gridSettings\" columns=\"stateController.columns\" default-sort=\"'Id'\" name-singular=\"'Validation Setting'\" show-add-button=\"false\"> </record-grid-view> ";
// Exports
export default code;